import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
  Typography,
  MenuItem,
  Select,
  IconButton,
  TextField,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "@apollo/client";
import { UPDATE_EMPLOYEE } from "../../../../../../apis/organization-apis/people-apis/peopleApis";
import ConfirmSnackbar from "../../../../../../components/Snackbar/ConfirmSnackbar";
import { LoadingButton } from "@mui/lab";

const AssignManagerAndRole = ({
  open,
  onClose,
  title,
  isTruto,
  staffMember,
  data,
  refetch,
  closeDetailDialog,
}) => {
  const [reportingManager, setReportingManager] = useState("");
  const [staffRole, setStaffRole] = useState("");
  const [snackbarInfo, setSnackbarInfo] = useState(null);
  const [updateEmployee, { loading, error }] = useMutation(UPDATE_EMPLOYEE);

  const TransitionComponent = (props) => {
    return <Slide {...props} direction="left" />;
  };

  const handleManagerChange = (event) => {
    setReportingManager(event.target.value);
  };

  const handleRoleChange = (event) => {
    setStaffRole(event.target.value);
  };

  const handleSave = async () => {
    const rolVariable = {
      employeeId: staffMember?.employeeId,
      jobTitle: staffRole ? staffRole : null,
    };

    const managerVariable = {
      employeeId: staffMember?.employeeId,
      managerId: reportingManager ? reportingManager : null,
    };

    try {
      const variables = title === "Assign Role" ? rolVariable : managerVariable;

      const response = await updateEmployee({ variables });

      refetch();
      onClose();
      closeDetailDialog();
      setSnackbarInfo({
        message: response?.data?.updateEmployee?.message,
        vertical: "top",
        horizontal: "right",
        Transition: TransitionComponent,
      });
    } catch (err) {
      console.error("Error updating employee:", err);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
        sx={{ "& .MuiDialog-paper": { minHeight: "570px" } }}
      >
        <DialogTitle fontWeight={"bold"}>
          {title}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {!isTruto ? (
          <DialogContent dividers>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <Avatar style={{ backgroundColor: "#031B89", marginRight: 16 }}>
                {staffMember?.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </Avatar>
              <div>
                <Typography variant="h5">{staffMember?.name}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {staffMember?.email}
                </Typography>
              </div>
            </div>

            {title === "Assign Manager" ? (
              <>
                <Typography variant="body2" style={{ marginBottom: 8 }}>
                  Reporting Manager
                </Typography>

                <Select
                  fullWidth
                  variant="outlined"
                  value={reportingManager}
                  onChange={handleManagerChange}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select Reporting Manager
                  </MenuItem>
                  <MenuItem value="">No Manager Assigned</MenuItem>
                  {data?.getEmployees?.data
                    .filter(
                      (val) => val.employee_id !== staffMember?.employeeId
                    )
                    .map((value, i) => (
                      <MenuItem value={value?.employee_id} key={i}>
                        {value?.name}
                      </MenuItem>
                    ))}
                </Select>
              </>
            ) : (
              <>
                <Typography variant="body2" style={{ marginBottom: 8 }}>
                  Staff Role
                </Typography>

                <TextField
                  fullWidth
                  variant="outlined"
                  value={staffRole}
                  onChange={handleRoleChange}
                  placeholder="Enter Staff Role"
                />
              </>
            )}
          </DialogContent>
        ) : (
          <DialogContent dividers></DialogContent>
        )}
        {!isTruto && (
          <DialogActions>
            <Button
              onClick={onClose}
              style={{ color: "#002D9C" }}
              variant="outlined"
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              onClick={handleSave}
              loading={loading}
            // disabled={!reportingManager !! !staffRole}
            >
              Save
            </LoadingButton>
          </DialogActions>
        )}
        {error && (
          <Typography
            variant="body2"
            color="error"
            style={{ margin: "8px 16px" }}
          >
            {error.message}
          </Typography>
        )}
      </Dialog>
      <ConfirmSnackbar snackbarInfo={snackbarInfo} />
    </>
  );
};

export default AssignManagerAndRole;
